function getYearFromRange(yearRange) {
  const splittedYearRange = yearRange.split('-');

  if (splittedYearRange.length === 2) {
    return splittedYearRange[1];
  }

  return splittedYearRange[0];
}

function expandYearRange(landingYearRange) {
  const yearRange = [];
  const splittedYearRange = landingYearRange.split('-');

  if (splittedYearRange.length === 2) {
    let [minYear] = splittedYearRange;
    const [, maxYear] = splittedYearRange;

    yearRange.push(minYear);

    while (minYear < maxYear) {
      yearRange.push(minYear++);
    }
  } else {
    yearRange.push(splittedYearRange[0]);
  }

  return yearRange;
}

function isYearSelectionDifferent(selectedVehicle, landingVehicle) {
  const { Make, Model, Year } = selectedVehicle;
  const { Make: landingMake, Model: landingModel, Year: landingYearRange } = landingVehicle;

  if (!landingYearRange || !landingMake || !landingModel) {
    return false;
  }

  const yearRange = expandYearRange(landingYearRange);

  return !yearRange.includes(parseFloat(Year)) || Make !== landingMake || Model !== landingModel;
}

function isGenerationSelectionDifferent(selectedVehicle, landingVehicle) {
  const { Make, Model, Generation } = selectedVehicle;
  const { Make: landingMake, Model: landingModel, Generation: landingGeneration } = landingVehicle;

  if (!landingMake || !landingModel || !landingGeneration) {
    return false;
  }

  return Make !== landingMake || Model !== landingModel || Generation !== landingGeneration;
}

function isSelectionDifferent(selectedVehicle, landingVehicle, vehicleLandingFields) {
  if (vehicleLandingFields.includes('Generation')) {
    return isGenerationSelectionDifferent(selectedVehicle, landingVehicle);
  }

  return isYearSelectionDifferent(selectedVehicle, landingVehicle);
}

function parsePipeSeparatedVehicle(raw, vehicleLandingFields) {
  if (!raw) {
    return null;
  }

  const values = raw.split('|').map((v) => v.trim());

  return Object.fromEntries(vehicleLandingFields.map((field, index) => [field, values[index] || '']));
}

function hasRequiredValues(vehicle, vehicleLandingFields) {
  return vehicleLandingFields.every((field) => !!vehicle[field]);
}

function toSelectedVehicle(vehicle, vehicleLandingFields, { fromLanding = false } = {}) {
  const selectedVehicle = Object.fromEntries(vehicleLandingFields.map((field) => [field, vehicle[field]]));

  if (fromLanding && vehicleLandingFields.includes('Year') && selectedVehicle.Year) {
    selectedVehicle.Year = getYearFromRange(selectedVehicle.Year);
  }

  return selectedVehicle;
}

export function createVehicleLandingSync(vehicleLandingFields) {
  return function syncLandingVehicle() {
    if (!window.document.body.classList.contains('cm_page-with-vehicle')) {
      return;
    }

    const selectedVehicle = window.Convermax.getVehicle() || {};
    const rawLandingVehicle = window.Convermax.landingVehicle?.replaceAll('["', '').replaceAll('"]', '');
    const rawSaveVehicle = window.Convermax.saveVehicleIntoGarage;
    const landingVehicle = parsePipeSeparatedVehicle(rawLandingVehicle, vehicleLandingFields);
    const savedVehicle = parsePipeSeparatedVehicle(rawSaveVehicle, vehicleLandingFields);

    if (savedVehicle && landingVehicle) {
      if (
        hasRequiredValues(savedVehicle, vehicleLandingFields) &&
        isSelectionDifferent(selectedVehicle, landingVehicle, vehicleLandingFields)
      ) {
        window.Convermax.setVehicle(toSelectedVehicle(savedVehicle, vehicleLandingFields));
      }
    } else if (landingVehicle) {
      if (isSelectionDifferent(selectedVehicle, landingVehicle, vehicleLandingFields)) {
        window.Convermax.setVehicle(
          toSelectedVehicle(landingVehicle, vehicleLandingFields, { fromLanding: true }),
        );
      }
    } else if (savedVehicle) {
      if (
        hasRequiredValues(savedVehicle, vehicleLandingFields) &&
        isSelectionDifferent(selectedVehicle, savedVehicle, vehicleLandingFields)
      ) {
        window.Convermax.setVehicle(toSelectedVehicle(savedVehicle, vehicleLandingFields));
      }
    }
  };
}
